import React from "react";
import { Link } from "react-router-dom";
import "./menuLeftPhone.css";
//
import logo from "../../../assets/logo/logo2.png";
//
import { MdOutlineAttachMoney } from "react-icons/md";
import {
  FaFileSignature,
  FaClipboardList,
  FaUserAlt,
  FaHandsHelping,
} from "react-icons/fa";
import { FaDeleteLeft } from "react-icons/fa6";
import { GoFileSubmodule } from "react-icons/go";
import { RiLockPasswordFill } from "react-icons/ri";
import Cookies from "js-cookie";
import { useNavigate } from "react-router-dom";

const MenuPhoneProvComer = ({ viewSee }) => {
  const navigate = useNavigate();

  const changeviewprov = (e, page) => {
    e.preventDefault();
    viewSee(page);
  };

  const handleLogout = () => {
    Cookies.remove("token");
    Cookies.remove("adminType");
    sessionStorage.removeItem("Data");
    navigate("/");
  };

  return (
    <div className="boxphonemenucel">
      <div>
        <div className="boxlogophonemenu">
          <img src={logo} alt="logo" />
        </div>
        <div className="flexbuttonsphone">
          <div className="buttonsphone">
            <Link to="/portal-comercializadores/mis-ventas">
              <p className="textcel">
                <MdOutlineAttachMoney className="phoneicon" />
                Mis ventas
              </p>
            </Link>
          </div>
          <div
            className="buttonsphone"
            onClick={(e) => changeviewprov(e, "Perfil")}
          >
            <p className="textcel">
              <FaUserAlt className="phoneicon" />
              Perfil
            </p>
          </div>
        </div>
        <div className="flexbuttonsphone">
          <div
            className="buttonsphone"
            onClick={(e) => changeviewprov(e, "Convenio")}
          >
            <p className="textcel">
              <FaFileSignature className="phoneicon" />
              Convenio con entidad
            </p>
          </div>
          <div
            className="buttonsphone"
            onClick={(e) => changeviewprov(e, "Factura")}
          >
            <p className="textcel">
              <FaHandsHelping className="phoneicon" />
              Subir factura
            </p>
          </div>
        </div>
        <div className="flexbuttonsphone">
          <div
            className="buttonsphone"
            onClick={(e) => changeviewprov(e, "Documentacion")}
          >
            <p className="textcel">
              <GoFileSubmodule className="phoneicon" />
              Mi documentacion
            </p>
          </div>

          <div className="buttonsphone buttonfinal">
            <p className="textcel">
              <RiLockPasswordFill className="phoneicon" />
              Cambiar <br /> contraseña
            </p>
          </div>
        </div>

        <div className="flexbuttonsphone">
          <Link to="/portal-comercializadores/mis-ventas">
            <div className="buttonsphone">
              <p className="textcel">
                <FaClipboardList className="phoneicon" />
                Mis facturas
              </p>
            </div>
          </Link>

          <div className="buttonsphone buttonfinal" onClick={handleLogout}>
            <p className="textcel">
              <FaDeleteLeft className="phoneicon" />
              Salir
            </p>
          </div>
        </div>
      </div>
    </div>
  );
};

export default MenuPhoneProvComer;
